module.exports = __webpack_public_path__ + "static/img/text-intro-btn-fr.4341af6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/wait/img/text-intro-btn-fr.png
// module id = KClO
// module chunks = 1